import actionTypes from 'SRC/modules/redux/actionTypes'

export const setTextSearchMessage = message => ({
  type: actionTypes.SET_VEHICLE_PARTS_TEXT_SEARCH_MESSAGE,
  payload: message
})
